export default __webpack_public_path__ + "static/media/logo.185a60ca.svg";